// extracted by mini-css-extract-plugin
export var aircallIframe = "_kq-3";
export var fabContainer = "_kq-5";
export var fabRinging = "_kq-6";
export var loadingOverlay = "_kq-4";
export var pulse = "_kq-7";
export var widgetContent = "_kq-2";
export var widgetPanel = "_kq-0";
export var widgetPanelExpanded = "_kq-1";